<template>
    <div class="clientes" id="clientes">
        <div class="content">
            <div class="titulo">
                <b-row>
                    <b-col cols="12" md>
                        <div class="linea lineaIzquierda"></div>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <p v-if="lang == 'eng'">some of our customers</p>
                        <p v-else-if="lang == 'esp'">algunos de nuestros clientes</p>
                    </b-col>
                    <b-col cols>
                        <div class="linea lineaDerecha"></div>
                    </b-col>
                </b-row>
            </div>
            <slick ref="slick" :options="slickOptions">
                <div>
                    <a href="https://rendichicas.com/" target="_blank"><img src="../assets/img/icn_cliente1.png" alt="Cliente"></a>
                </div>
                <div>
                    <a href="http://www.pbhabogados.com/" target="_blank"><img src="../assets/img/icn_cliente2.png" alt="Cliente"></a>
                </div>
                <div>
                    <a href="https://www.facebook.com/EXPOCervezaArtesanal/" target="_blank"><img src="../assets/img/icn_cliente3.png" alt="Cliente"></a>
                </div>
                <div>
                    <a href="https://gaiaresidencial.com/" target="_blank"><img src="../assets/img/icn_cliente4.png" alt="Cliente"></a>
                </div>
                <div>
                    <a href="http://rvs-cia.com.mx/" target="_blank"><img src="../assets/img/icn_cliente5.png" alt="Cliente"></a>
                </div>
                <div>
                    <a href="https://www.facebook.com/delvillarins/" target="_blank"><img src="../assets/img/icn_cliente6.png" alt="Cliente"></a>
                </div>
            </slick>
        </div>
    </div>
</template>

<script>
    import Slick from 'vue-slick'
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        },
        components: {
            Slick
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 6,
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    responsive: [
                        {
                        breakpoint: 575,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                          breakpoint: 767,
                            settings: {
                              slidesToShow: 3,
                              slidesToScroll: 3
                            }
                        },
                        {
                          breakpoint: 991,
                            settings: {
                              slidesToShow: 4,
                              slidesToScroll: 4
                            }
                        }
                    ]
                },
            };
        },
        methods: {
            next() {
                this.$refs.slick.next()
            },
            prev() {
                this.$refs.slick.prev()
            },
            reInit() {
                this.$refs.slick.reSlick()
            }
        }
    }
</script>

<style scoped>
    .clientes{
        /* padding: 60px 0; */
    }
    img{
        width: 100%;
        transition: transform .2s;
    }
    img:hover {
        transform: scale(1.1); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    }
    a{
        outline: none!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Clientes.vue